<form
    *ngIf="
        attachmentAvailable && attachments !== undefined && attachments !== null
    "
    [formGroup]="form"
>
    <div class="zas-row">
        <div class="zas-main-col">
            <span
                >Anlagen (maximal {{ maxFileCount }} Dateien im Format PDF,
                maximal {{ (maxFileLength / 1024 / 1024).toFixed(1) }} MiB pro
                Datei)</span
            >
        </div>
    </div>
    <ul *ngIf="attachments && attachments.length > 0">
        <li *ngFor="let attachment of attachments" class="zas-row">
            <a (click)="consultationService.downloadAttachment(attachment)">{{
                removeFileExtension(attachment.Name)
            }}</a>
            <span
                class="zas-header-icon icon-close-tag"
                (click)="deleteAttachment(attachment)"
            ></span>
        </li>
    </ul>
    <div class="zas-row">
        <div class="zas-main-col">
            <div
                *ngIf="attachments.length < maxFileCount"
                class="input-container form-group"
            >
                <div class="fileInput-box">
                    <input
                        #fileInput
                        class="fileInput"
                        formControlName="FileInput"
                        type="file"
                        placeholder="Dateiname"
                        (change)="onFileSelected($event)"
                    />
                    <div (click)="addAttachment()">
                        <span
                            class="zas-header-icon icon-add"
                            style="margin-right: 2px; font-size: 30px"
                        ></span>
                        <span class="zbd-inline-button">Anlage hinzufügen</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
